// extracted by mini-css-extract-plugin
export default {"list":"list_OKfXKJE","list_disc":"list_disc_HAa4YCA","list_inline":"list_inline_L81yFu8","item":"item_NHXV3uQ","list_narrow":"list_narrow_SrXimkZ"};